/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPowerPlugDiagIcon20Solid = forwardRef('TechPowerPlugDiagIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14.662 1.14a1.25 1.25 0 0 1 0 1.767l-2.828 2.828 2.43 2.43 2.829-2.828a1.25 1.25 0 0 1 1.768 1.768l-2.829 2.828.862.862a1.25 1.25 0 0 1 0 1.768l-1.746 1.746a6.69 6.69 0 0 1-8.277.94l-3.788 3.788a1.5 1.5 0 1 1-2.121-2.121l3.788-3.788a6.69 6.69 0 0 1 .94-8.277l1.747-1.745a1.25 1.25 0 0 1 1.767 0l.862.861 2.829-2.828a1.25 1.25 0 0 1 1.767 0Z" })));
});
